<template>
    <section id="additional-costs" class="scroll-mt-24">
        <h3 class="text-lg font-semibold mb-6">{{ $t('Additional costs') }}</h3>
        <div class="text-sm">
            <table class="w-full table-auto">
                <tbody>
                    <template v-for="_item in item.additionalCosts">
                        <tr>
                            <td width="40%" class="text-gray-800 font-semibold py-1.5">{{ _item.name }}</td>
                            <td class="text-gray-600">
                                <template v-if="_item.priceValue == 0">{{ $t('Included in price') }}</template>
                                <template v-else>
                                    <span class="lowercase">
                                        {{ [$n(_item.priceValue, 'currency') + ' / ' + _item.priceType.label, _item.obligated ? $t('Mandatory surcharge') : null, _item.payAtLocation == 1 ? $t('At reception') : _item.payAtLocation == 0 ? $t('At reservation') : null].filter(Boolean).join(', ') }}
                                    </span>
                                </template>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true
    }
})
</script>
